import axios from 'axios';
import JwtService from '@/services/jwt-service';
import {
  i18n
} from '@/plugins/i18n-setup';

const apiClient = axios.create({
  // baseURL: 'http://127.0.0.1:8000/api',
  baseURL: 'https://app.nushenamel.am/api',
  withCredentials: false, // This is the default
  responseType: 'json',
  transformRequest: [
    function (data, headers) {
      // app.$Progress.start()
      headers['Accept-Language'] = i18n.locale;
      // headers['Accept-Language'] = 'hy'
      return JSON.stringify(data);
    }
  ],
  transformResponse: [
    function (data) {
      if (typeof data === 'string') {
        return JSON.parse(data);
      } else {
        return data;
      }
    }
  ],
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: 'Bearer ' + JwtService.getToken()
  }
});

export default {
  get (resource, slug = '') {
    return apiClient.get(`${resource}/${slug}`);
  },
  post (resource, params) {
    return apiClient.post(`${resource}`, params);
  },
  update (resource, slug, params) {
    return apiClient.put(`${resource}/${slug}`, params);
  },
  delete (resource) {
    return apiClient.delete(resource);
  }
};
